// TODO: delete and replace usage with PageType enum from graphql-types once back-end change for PLP is merged/deployed
export const PageTypes = {
  CART: 'CART',
  CHECKOUT: 'CHECKOUT',
  PDP: 'PDP'
} as const;
